import React, {Component, Fragment} from 'react';
import '../../Common/Common.css';
import './QuotationForm.css';
import '../../Common/ResponsiveQuotationForm.css';
import PCBQuotationForm from './PCBQuotationForm/PCBQuotationForm';
import StencilQuotationForm from './StencilQuotationForm/StencilQuotationForm';
import QuotationPriceInformation from "../PriceInformation/PriceInformation";
import {FormattedMessage} from "react-intl";
import axios from "axios";
import {GOOGLE_ANALYTICS_CODE, IS_IN_MOBILE_MODE, PAGE_OPEN_TYPE, RESOURCE_BASE_URL} from "../../../configuration";
import InitialQuotationState from "./InitialQuotationState";
import QuotationSummary from "../QuotationSummary/QuotationSummary";
import {Link} from "react-router-dom";
import InitialAdminState from "../../Admin/AdminRoot/InitialAdminState";
import StencilCustomizedSize from "./StencilQuotationForm/StencilCustomizedSize/StencilCustomizedSize";
import PriceLoadingImage from "../../../assets/img/loading_price.gif";
import Modal from "react-bootstrap/es/Modal";
import ReactGA from "react-ga";


const QuotationModeButtonGroupDisabled = (props) => {
    let pcbMode = false;

    let orderType = props.orderType;

    if (orderType === 1 || orderType === 2) {
        pcbMode = true;
    }
    if (pcbMode) {
        return (
            <div className="pcb-stencil-toggle-buttons">
                <div className="pcb-button-div col-md-6 text-right no-padding">
                    <div id="pcb" className="toggle-button-form text-center toggle-button-active">
                        <div className="">
                            <div className="col-md-12 pcb-stncl-name">
                                <label>
                                    <FormattedMessage id="app.pcb-quotation.pcb-gerber-button-pcb"
                                                      defaultMessage="PCB"
                                                      description=""/>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="stencil-button-div col-md-6 text-left no-padding">
                    <div className="toggle-button-form text-center">
                        <div className="">
                            <div className="col-md-12 pcb-stncl-name">
                                <label>
                                    <FormattedMessage id="app.pcb-quotation.pcb-gerber-button-stencil"
                                                      defaultMessage="STENCIL"
                                                      description=""/>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    } else {
        return (
            <div className="pcb-stencil-toggle-buttons">
                <div className="pcb-button-div col-md-6 text-right no-padding">
                    <div className="toggle-button-form text-center">
                        <div className="">
                            <div className="col-md-9 pcb-stncl-name">
                                <label>
                                    <FormattedMessage id="app.pcb-quotation.pcb-gerber-button-pcb"
                                                      defaultMessage="PCB"
                                                      description=""/>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="stencil-button-div col-md-6 text-left no-padding">
                    <div className="toggle-button-form toggle-button-active text-center">
                        <div className="">
                            <div className="col-md-9 pcb-stncl-name">
                                <label>
                                    <FormattedMessage id="app.pcb-quotation.pcb-gerber-button-stencil"
                                                      defaultMessage="STENCIL"
                                                      description=""/>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
};


const QuotationModeButtonGroup = (props) => {
    if (props.pcbMode) {
        return (
            <div className="pcb-stencil-toggle-buttons">
                <Link to={{
                    pathname: '/quotation/pcb',
                    pcbMode: true,
                    isFromTab: true
                }}>
                    <div className="pcb-button-div col-md-6 text-right no-padding">

                        <button onClick={props.pcbButtonClicked} id="pcb"
                                className="toggle-button-form toggle-button-active">
                            <div className="">
                                {/*<div className="col-md-3">*/}
                                {/*<img src={ImagePCB} alt="Image" className="pcb-stncl-image"/>*/}
                                {/*</div>*/}
                                <div className="col-md-12 pcb-stncl-name pcb-stncl-name-unsetmargin">
                                    <label>
                                        <FormattedMessage id="app.pcb-quotation.pcb-gerber-button-pcb"
                                                          defaultMessage="PCB"
                                                          description=""/>
                                    </label>
                                </div>
                            </div>
                        </button>
                    </div>
                </Link>
                <Link to={{
                    pathname: '/quotation/stencil',
                    pcbMode: false,
                    isFromTab: true
                }}>
                    <div className="stencil-button-div col-md-6 text-left no-padding">
                        <button onClick={props.stencilButtonClicked} className="toggle-button-form" id="stencil">
                            <div className="">
                                {/*<div className="col-md-3">*/}
                                {/*<img src={ImageStencil} alt="Image" className="pcb-stncl-image"/>*/}
                                {/*</div>*/}
                                <div className="col-md-12 pcb-stncl-name pcb-stncl-name-unsetmargin">
                                    <label>
                                        <FormattedMessage id="app.pcb-quotation.pcb-gerber-button-stencil"
                                                          defaultMessage="STENCIL"
                                                          description=""/>
                                    </label>
                                </div>
                            </div>
                        </button>
                    </div>
                </Link>
            </div>
        )
    } else {
        return (
            <div className="pcb-stencil-toggle-buttons">
                <Link to={{
                    pathname: '/quotation/pcb',
                    pcbMode: true,
                    isFromTab: true
                }}>
                    <div className="pcb-button-div col-md-6 text-right no-padding">
                        <button onClick={props.pcbButtonClicked} className="toggle-button-form" id="pcb">
                            <div className="row">
                                {/*<div className="col-md-3">*/}
                                {/*<img src={ImagePCB} alt="Image" className="pcb-stncl-image"/>*/}
                                {/*</div>*/}
                                <div className="col-md-9 pcb-stncl-name pcb-stncl-name-unsetmargin">
                                    <label>
                                        <FormattedMessage id="app.pcb-quotation.pcb-gerber-button-pcb"
                                                          defaultMessage="PCB"
                                                          description=""/>
                                    </label>
                                </div>
                            </div>
                        </button>
                    </div>
                </Link>
                <Link to={{
                    pathname: '/quotation/stencil',
                    pcbMode: false,
                    isFromTab: true
                }}>
                    <div className="stencil-button-div col-md-6 text-left no-padding">
                        <button onClick={props.stencilButtonClicked}
                                className="toggle-button-form toggle-button-active" id="stencil">
                            <div className="row">
                                {/*<div className="col-md-3">*/}
                                {/*<img src={ImageStencil} alt="Image" className="pcb-stncl-image"/>*/}
                                {/*</div>*/}
                                <div className="col-md-9 pcb-stncl-name pcb-stncl-name-unsetmargin">
                                    <label>
                                        <FormattedMessage id="app.pcb-quotation.pcb-gerber-button-stencil"
                                                          defaultMessage="STENCIL"
                                                          description=""/>
                                    </label>
                                </div>
                            </div>
                        </button>
                    </div>
                </Link>
            </div>
        )
    }
};

const CancelToken = axios.CancelToken;
let cancel;

let quotatioHeight;

class QuotationForm extends Component {
    // componentDidMount() {
    //     window.scrollTo(0, 0)
    // }

    constructor(props) {
        super(props);
        // alert(props.location.pcbMode);
        this.state = {
            userId: this.props.userId,
            // pcbMode: true,
            pcbMode: props.location.pcbMode !== undefined ? props.location.pcbMode : true,
            isFromTab: false,
            editMode: false,
            gerberImageData: InitialQuotationState.gerberImageData,
            quotation: props.location.quotation !== undefined ? props.location.quotation : InitialQuotationState.quotation,
            priceInformation: InitialQuotationState.priceInformation,
            mainPriceInformation: InitialQuotationState.mainPriceInformation,
            cssStylePCBDisplay: {display: 'block'},
            cssStyleStencilDisplay: {display: 'block'},
            show: false,
            showPricingErrorDialog: false,
            loadingPrice: true,
            errorMessage: null,
            showPricingModal: false,
            gerberError : false
        };

        this.pcbButtonClicked = this.pcbButtonClicked.bind(this);
        this.stencilButtonClicked = this.stencilButtonClicked.bind(this);
        this.setRemarks = this.setRemarks.bind(this);
        this.setQuantity = this.setQuantity.bind(this);
        this.setDimensions = this.setDimensions.bind(this);
        this.pcbWithStencilFormActivated = this.pcbWithStencilFormActivated.bind(this);
        this.setPCBParams = this.setPCBParams.bind(this);
        this.setStencilParams = this.setStencilParams.bind(this);
        this.setGerberImageData = this.setGerberImageData.bind(this);
        this.getPriceInfo = this.getPriceInfo.bind(this);
        this.initializeUpdatedState = this.initializeUpdatedState.bind(this);
        this.validateDimension = this.validateDimension.bind(this);
        this.updateGerberImageDataOnEdit = this.updateGerberImageDataOnEdit.bind(this);
        this.setPCBQuantity = this.setPCBQuantity.bind(this);
        this.setDifferentDesign = this.setDifferentDesign.bind(this);
        this.setCustomizedSize = this.setCustomizedSize.bind(this);
        this.turnOnOverlay = this.turnOnOverlay.bind(this);
        this.turnOffOverlay = this.turnOffOverlay.bind(this);
        this.handleClosePricingErrorDialog = this.handleClosePricingErrorDialog.bind(this);
        this.showPricingModal = this.showPricingModal.bind(this);
        this.closePricingModal = this.closePricingModal.bind(this);
        this.clearLocalStorage = this.clearLocalStorage.bind(this);
        this.setPCBParamsWhenGerberUpload = this.setPCBParamsWhenGerberUpload.bind(this);
        this.setGerberError = this.setGerberError.bind(this);
        this.unsetGerberError = this.unsetGerberError.bind(this);
        this.setMainPriceInfo = this.setMainPriceInfo.bind(this);
        this.setLoadingPriceOnOff = this.setLoadingPriceOnOff.bind(this);
    }
    setLoadingPriceOnOff = (status) => {
        this.setState({
            loadingPrice : status
        })
    };

    setMainPriceInfo = (mainPriceInformation) => {
        this.setState({
            mainPriceInformation
        })
    };

    setGerberError = () => {
        this.setState({
            gerberError : true
        })
    };
    unsetGerberError = () => {
        this.setState({
            gerberError : false
        })
    };
    showPricingModal = () => {
        this.setState({
            showPricingModal: true
        }, ()=>{
            document.getElementById("price-summery-fixed").style.display = "none";
        })
    };
    closePricingModal = () => {

        this.setState({
            showPricingModal: false
        }, ()=>{
            document.getElementById("price-summery-fixed").style.display = "block";
        })
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.userData !== this.props.userData) {
            this.setState({userId: this.props.userId});
        }

        quotatioHeight = document.getElementsByClassName('test-quotation-content')[0].clientHeight - document.getElementsByClassName('pricing-inline')[0].clientHeight - 100;
        InitialQuotationState.quotationSumHeight = quotatioHeight;


    }

    handleClosePricingErrorDialog = () => {
        this.setState({
            showPricingErrorDialog: false
        })
    };

    componentDidMount() {

        if(IS_IN_MOBILE_MODE){
            let chatElement = document.getElementById("chat-outer-div-app");
            if(chatElement !== null){
                chatElement.style.display = "none";
            }

            setTimeout(()=>{
                let scrollTopBtn = document.getElementsByClassName("ScrollUpButton__Container")[0];
                scrollTopBtn.style.display = "none";
                let scrollTopBtnQuo = document.getElementsByClassName("ScrollUpButton__Container_quo")[0];
                scrollTopBtnQuo.style.display = "block";
            },300);
        }


        if (window.innerWidth < 320) {
            let chatDiv = document.getElementById('chat-outer-div-app');
            if (chatDiv.firstElementChild !== null) {
                chatDiv.firstElementChild.firstElementChild.style.position = 'fixed';
                chatDiv.firstElementChild.firstElementChild.style.bottom = '105px';
            }
            let scrollDiv = document.getElementById("scroll-outer-div-app");
            scrollDiv.firstElementChild.style.bottom = '105px';
        }


        if (parseInt(localStorage.getItem("type")) === 1) {

            let quotation = localStorage.getItem("type1q") !== null ? JSON.parse(localStorage.getItem("type1q")) : InitialQuotationState.quotation
            if (quotation.pcbParam.layer === 6) {
                quotation.pcbParam.pcbColor = 0;
                if(parseInt(localStorage.getItem("fromNavi")) === 1 ){
                    quotation.pcbParam.layer = 2;
                }
            }
            if(quotation.pcbParam.qty === 10){
                if(parseInt(localStorage.getItem("fromNavi")) === 1 ){
                    quotation.pcbParam.qty = 5;
                }
            }

            if(quotation.pcbParam.thickness !== 0.4){
                quotation.pcbParam.surfaceFinish = 0;
            }
            if(parseInt(localStorage.getItem("fromNavi")) === 2){
                quotation.pcbParam.layer = 2;
                quotation.pcbParam.thickness = 1.6;
                quotation.pcbParam.surfaceFinish = 0;
                quotation.pcbParam.qty = 5;

                if(parseInt(localStorage.getItem("type")) === 3){
                    let elm = document.getElementById("stencil");
                    // console.log("stencil ID ====> ", elm);

                    setTimeout(()=>{
                        if(elm !== null){
                            elm.click();
                        }
                    }, 1000);
                }else {
                    let elm = document.getElementById("pcb");
                    // console.log("PCB ID ====> ", elm);
                    setTimeout(()=> {
                        if(elm !== null){
                            elm.click();
                        }
                    }, 1000);
                }

            }

            let pcbMode = true;

            if(parseInt(localStorage.getItem("type")) === 3){
                pcbMode = false
            }

            this.setState({
                quotation,
                pcbMode: pcbMode
            }, () => this.getPriceInfo());

        } else if (parseInt(localStorage.getItem("type")) === 3) {
            this.setState({
                quotation: localStorage.getItem("type3q") !== null ? JSON.parse(localStorage.getItem("type3q")) : InitialQuotationState.quotation3,
                pcbMode: false
            }, () => {

                let elm = document.getElementById("stencil");
                // console.log("stencil ID ====> ", elm);

                setTimeout(()=>{
                    if(elm !== null){
                        elm.click();
                    }
                }, 1000);

                this.getPriceInfo();
            });

        }else {
            let quotation = {...this.state.quotation};

            quotation.pcbParam.layer = 2;
            quotation.pcbParam.qty = 5;
            quotation.pcbParam.thickness = 1.6;
            quotation.pcbParam.pcbColor = 0;
            quotation.pcbParam.surfaceFinish = 0;


            this.setState({
                quotation
            })
        }

        window.scrollTo(0, 0);

        let itemId = this.props.match.params.itemId;
        if (itemId && InitialQuotationState.cartItemEditMode === true) {
            InitialQuotationState.editCartItemId = itemId;
            this.state.cssStylePCBDisplay = {display: 'none'};
            this.state.cssStyleStencilDisplay = {display: 'none'};
            this.getUpdateItemDetails(itemId);

        } else {
            this.state.cssStylePCBDisplay = {display: 'block'};
            this.state.cssStyleStencilDisplay = {display: 'block'};
            this.getPriceInfo();
        }
        this.setState({
            isFromTab: this.props.location.isFromTab
        });

        InitialQuotationState.gerberImageData = {
            fileUrl: "",
            id: -1,
            imageUrl: "",
            imageUrlBottom: "",
            imageUrlTop: "",
            key: "",
            originalFileName: ""
        };


        quotatioHeight = document.getElementsByClassName('test-quotation-content')[0].clientHeight - document.getElementsByClassName('pricing-inline')[0].clientHeight - 100;
        InitialQuotationState.quotationSumHeight = quotatioHeight;

    }

    clearLocalStorage = () => {
        localStorage.removeItem("type");
        localStorage.removeItem("type1q");
        localStorage.removeItem("type3q");
        localStorage.removeItem("fromNavi");
    };


    turnOnOverlay = () => {
        document.getElementById("overlay-quo").style.display = "block";
    };
    turnOffOverlay = () => {
        document.getElementById("overlay-quo").style.display = "none";
    };

    setCustomizedSize = (valueX,valueY, okBtn) => {
        let quotation = {...this.state.quotation};

        if (okBtn === "ok") {

            if(parseFloat(valueX) === 0 || parseFloat(valueY) === 0){
                quotation.smtStencilParam.customizeFlag = 0;
                quotation.smtStencilParam.customizeSizeX = 0;
                quotation.smtStencilParam.customizeSizeY = 0;
                InitialQuotationState.conformBtn = false;
            }else {
                quotation.smtStencilParam.customizeFlag = 1;
                quotation.smtStencilParam.customizeSizeX = parseFloat(valueX);
                quotation.smtStencilParam.customizeSizeY = parseFloat(valueY);
                InitialQuotationState.conformBtn = true;
            }

        }else {
            InitialQuotationState.conformBtn = false;
        }

        this.setState({
            quotation,
            show: false
        }, () => {
            // this.getPriceInfo();
        });


    };

    componentWillUnmount() {

        if(IS_IN_MOBILE_MODE){
            let chatElement = document.getElementById("chat-outer-div-app");
            chatElement.style.display = "block";

            let scrollTopBtn = document.getElementsByClassName("ScrollUpButton__Container")[0];
            scrollTopBtn.style.display = "block";
            let scrollTopBtnQuo = document.getElementsByClassName("ScrollUpButton__Container_quo")[0];
            scrollTopBtnQuo.style.display = "none";
        }

        this.clearLocalStorage();

        if (window.innerWidth < 320) {
            let chatDiv = document.getElementById('chat-outer-div-app');
            if (chatDiv.firstElementChild !== null) {

                chatDiv.firstElementChild.firstElementChild.style.position = 'fixed'
                chatDiv.firstElementChild.firstElementChild.style.bottom = '20px';
            }
            let scrollDiv = document.getElementById("scroll-outer-div-app");
            scrollDiv.firstElementChild.style.bottom = '20px'
        }
        InitialQuotationState.qsdcls = '';
        let quotation = {...this.state.quotation};
        let imageDataGerber = {
            fileUrl: "",
            id: -1,
            imageUrl: "",
            imageUrlBottom: "",
            imageUrlTop: "",
            key: "",
            originalFileName: ""
        };
        quotation.smtStencilParam.customizeSizeX = 0;
        quotation.smtStencilParam.customizeSizeY = 0;
        // quotation.smtStencilParam.conformBtn = false;
        InitialQuotationState.conformBtn = false;
        InitialQuotationState.gerberImageData = imageDataGerber;
        this.setState({
            gerberImageData: imageDataGerber
        })

        InitialQuotationState.heightSet = ''
    }

    setDifferentDesign = (event) => {
        // console.log("DUO DIFFERENT DESIGN ====> ", event.target.value);
        InitialAdminState.radioBtnClick = false;
        let quotation = {...this.state.quotation};
        const pattern = /^-?\d*\.?\d*$/;
        var rex = /[\uFF10-\uFF19]/g;

        let val2 = event.target.value;

        val2 = val2.replace(rex, function(ch) {
            return String.fromCharCode(ch.charCodeAt(0) - 65248);
        });


        let designValue = val2.replace(/\s/g, '');

        if (designValue < 50) {
            if (designValue.match(pattern)) {
                if (designValue === "") {
                    quotation.pcbParam[event.target.name] = "";

                } else {
                    quotation.pcbParam[event.target.name] = parseInt(designValue);

                }

                // quotation.pcbParam[event.target.name] = parseInt(event.target.value);

            }
        } else {
            quotation.pcbParam[event.target.name] = 50;
        }
        this.setState({quotation}, () => this.getPriceInfo());


    };

    initializeUpdatedState = (data) => {


        let quotation = {...InitialQuotationState.quotation};
        let pcbParams = data.quotation.pcbParam;
        let stencilParams = data.quotation.stencilParam;
        // this.updateGerberImageDataOnEdit(data.quotation.fileKey);

        switch (data.quotation.orderType) {
            case 1:
                quotation.orderType = data.quotation.orderType;
                quotation.pcbParam = pcbParams;
                break;
            case 2:
                quotation.orderType = 2;
                quotation.pcbParam = pcbParams;
                quotation.smtStencilParam = stencilParams;
                break;
            case 3:
                quotation.orderType = 3;
                quotation.smtStencilParam = stencilParams;
                break;
            default:
                break;
        }

        if (data.quotation.orderType === 3) {
            this.setState({
                    quotation,
                    pcbMode: false,
                    editMode: true,
                    gerberImageData: InitialQuotationState.gerberImageData
                },
                () => {
                    this.getPriceInfo();
                });
        } else {
            this.setState({
                    quotation,
                    editMode: true,
                    gerberImageData: InitialQuotationState.gerberImageData
                },
                () => {
                    this.getPriceInfo();
                });
        }

    };

    getUpdateItemDetails = (itemId) => {

        let resourceUrl = RESOURCE_BASE_URL + 'api/users/' + this.props.userId + '/cart/item/edit/' + itemId;
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.get(resourceUrl, axiosConfig)
            .then((res) => {
                console.log("edit item details ====> ", res.data);
                let pcbMode = true;

                let quotation = {...this.state.quotation};


                if(res.data.quotation.orderType === 3){

                    quotation.pcbParam = InitialQuotationState.quotation.pcbParam;
                    quotation.smtStencilParam = res.data.quotation.stencilParam;
                    quotation.smtStencilParam.framework = res.data.quotation.stencilParam.framework;
                    quotation.orderType = res.data.quotation.orderType;
                    quotation.fileKey = res.data.quotation.fileKey;
                    pcbMode = false

                }else if(res.data.quotation.orderType === 2){

                    // setTimeout(()=>{
                    //     document.getElementById("pcbWithStencil").click();
                    // },1500);
                    quotation.pcbParam = res.data.quotation.pcbParam;
                    quotation.smtStencilParam = res.data.quotation.stencilParam;
                    quotation.smtStencilParam.framework = res.data.quotation.stencilParam.framework;
                    quotation.orderType = res.data.quotation.orderType;
                    quotation.fileKey = res.data.quotation.fileKey;

                }else {
                    quotation.pcbParam = res.data.quotation.pcbParam;
                    quotation.smtStencilParam = res.data.quotation.stencilParam;
                    quotation.smtStencilParam.framework = res.data.quotation.stencilParam.framework;
                    quotation.orderType = res.data.quotation.orderType;
                    quotation.fileKey = res.data.quotation.fileKey;
                    quotation.pcbParam.edgeRails = res.data.edgeRails;
                }



                this.setState({
                    mainPriceInformation: res.data.mainPriceInfo,
                    errorMessage: null,
                    loadingPrice: false,
                    quotation,
                    pcbMode
                });




                // let resourceUrl = RESOURCE_BASE_URL + 'api/gerber/get/' + res.data.quotation.fileKey;
                //
                // let axiosConfig = {
                //     headers: {
                //         'Content-Type': 'application/json;charset=UTF-8',
                //         "Access-Control-Allow-Origin": "*",
                //     }
                // };
                // axios.get(resourceUrl, axiosConfig)
                //     .then((gerberRes) => {
                //         InitialQuotationState.gerberImageData = gerberRes.data;
                //         console.log("GERBER ITEM DATA ===> ", gerberRes.data);
                //
                //     })
                //     .catch((err) => {
                //         console.log("[API] ERROR: ", err);
                //     }).finally(() => {
                //     this.initializeUpdatedState(res.data);
                // });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    updateGerberImageDataOnEdit = (fileKey) => {

        let resourceUrl = RESOURCE_BASE_URL + 'api/gerber/get/' + fileKey;

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.get(resourceUrl, axiosConfig)
            .then((res) => {

                let quotation = {...this.state.quotation};
                quotation.fileKey = res.data.fileKey;
                this.setState({
                    gerberImageData: res.data,
                    quotation
                });

                InitialQuotationState.gerberImageData = res.data;


            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });

    };

    getPriceInfo = () => {
        this.setState({
            loadingPrice: true
        });
        InitialQuotationState.quotationErrorMessage = null;
        let priceInfoJson = {...this.state.quotation};

        this.mainPriceInformation && this.mainPriceInformation.loadingOn();

        // const CancelToken = axios.CancelToken;
        // let cancel;

        /* remove unwanted properties */
        delete priceInfoJson.fileKey;
        // delete priceInfoJson.smtStencilParam.framework;
        delete priceInfoJson.smtStencilParam.customizeSize;

        /* add additional properties */
        priceInfoJson.country = "HR";
        priceInfoJson.shippingMethod = "dhl";

        priceInfoJson.pcbParam.qty = this.state.quotation.pcbParam.qty;

        console.log("price info ====> ", priceInfoJson);


        let resourceUrl = RESOURCE_BASE_URL + 'api/jlcpcb/price/' + priceInfoJson.orderType;


        if (cancel) {
            cancel();
        }

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            },
            cancelToken: new CancelToken(function executor(c) {
                cancel = c;
                // console.log("cancelling previous request", c)
            })
        };


        // console.log("PRICE INFO JSON DUO =====> ", priceInfoJson);
        axios.post(resourceUrl, priceInfoJson, axiosConfig)
            .then((res) => {
                // console.log("Received response,", res);
                if (res.data.statusCode === "SUCCESS") {
                    this.setState({
                        mainPriceInformation: res.data.priceInfo,
                        errorMessage: null,
                        loadingPrice: false
                    });
                    InitialQuotationState.quotationErrorMessage = null;
                } else {
                    this.setState({
                        mainPriceInformation: InitialQuotationState.mainPriceInformation,
                        // showPricingErrorDialog: true,
                        // errorMessage: res.data.message,
                        errorMessage: "読み込みエラーが発生しました 、マイページからもう一度お試しください。",
                        loadingPrice: false
                    })
                    InitialQuotationState.quotationErrorMessage = '読み込みエラーが発生しました 、マイページからもう一度お試しください。';

                }
            })
            .catch((err) => {
                if (axios.isCancel(err)) {
                    console.log('post Request canceled ====> ', err);
                } else {

                    console.log("[API] ERROR: ", err);
                    this.setState({
                        errorMessage : '読み込みエラーが発生しました 、マイページからもう一度お試しください。'
                    }, ()=> this.setLoadingPriceOnOff(false));

                }

                this.setState({
                    // showPricingErrorDialog: true,
                    mainPriceInformation: InitialQuotationState.mainPriceInformation,
                    // errorMessage: "読み込みエラーが発生しました 、マイページからもう一度お試しください。",
                    // loadingPrice: false
                });
                InitialQuotationState.quotationErrorMessage = '読み込みエラーが発生しました 、マイページからもう一度お試しください。';
            });
    };

    setPCBParams = (params) => {
        let quotation = {...this.state.quotation};

        const {name, id} = params;


        quotation.pcbParam[name] = id;
        quotation.fileKey = InitialQuotationState.gerberImageData.id !== -1 ?
            InitialQuotationState.gerberImageData.fileKey : "";


        if (name === "panelFlag" && id === 1) {
            quotation.pcbParam["panelByJLCPCB_X"] = 1;
            quotation.pcbParam["panelByJLCPCB_Y"] = 1;
        }

        if (name === "thickness" && id < 1.6) {
            quotation.pcbParam["copperWeight"] = 1;
        }

        if (name === "pcbColor" && id === 4) {
            quotation.pcbParam["silkColor"] = 2
        } else if (name === "pcbColor" && id !== 4) {
            quotation.pcbParam["silkColor"] = 1
        }

        if (name === "thickness" && id === 0.4) {
            quotation.pcbParam["surfaceFinish"] = 2;
            quotation.pcbParam["panelFlag"] = 0;
        }
        if (name === "goldFinger" && id === 2) {
            quotation.pcbParam["surfaceFinish"] = 2;
        }

        if (name === "edgeQty") {
            quotation.pcbParam["castellatedHoles"] = id
        }
        if (name === "castellatedHoles" && id === 1) {
            quotation.pcbParam["orderDetailsRemark"] = "キャスタレーション = はい";
            quotation.pcbParam["edgeQty"] = 1
        } else if (name === "castellatedHoles" && id === 0) {
            quotation.pcbParam["orderDetailsRemark"] = "";
            delete quotation.pcbParam["edgeQty"];
        }
        if(name === "layer" && id === 1){
            if(quotation.pcbParam["thickness"] < 0.8 ){
                quotation.pcbParam["thickness"] = 1.6
            }
        }

        console.log("QUO AFTER ===> ", quotation);

        /* Fetch price information for updated quotation */
        this.setState({quotation}, () => this.getPriceInfo());
        console.log("QUOtation ===> ", quotation);

        InitialQuotationState.gerberFileKey = InitialQuotationState.gerberImageData.key;

    };

    setPCBParamsWhenGerberUpload = (status, params) => {

        let quotation = {...this.state.quotation};

        quotation.pcbParam[params.name] = params.id;

        this.setState({
            quotation
        }, ()=> {
            if(status === 1 ){
                this.getPriceInfo();
            }
        })

    };

    setStencilParams = (params) => {

        let quotation = {...this.state.quotation};
        const {name, id} = params;

        quotation.smtStencilParam[name] = id;

        if (name === "stencilQty") {
            quotation.smtStencilParam[name] = id === "" ? 0 : parseInt(id);
        }
        //
        // if (name === "stencilSide" && id === 3 && quotation.smtStencilParam.stencilQty < 2) {
        //     quotation.smtStencilParam["stencilQty"] = 2;
        // }
        if (name === "stencilQty" && id === "1" && quotation.smtStencilParam.stencilSide === 3) {
            quotation.smtStencilParam["stencilSide"] = 0;
        }

        if (name === "stencilSide" && id === 3) {
            quotation.smtStencilParam["stencilQty"] = 2;
        }

        if (name === "stencilQty" && id === "1" && quotation.smtStencilParam.stencilSide === 3) {
            quotation.smtStencilParam["stencilSide"] = 0;
        }

        // console.log("SMT PARAM ERROR ====> ", params);

        if (name === "customizeFlag" && id === 1) {
            this.setState({show: true});
        }
        if (name === "customizeFlag" && id === 0) {
            quotation.smtStencilParam["customizeSizeX"] = 0;
            quotation.smtStencilParam["customizeSizeY"] = 0;
            this.setState({
                show: false,
            });
            InitialQuotationState.conformBtn = false;

        }
        if(name === "framework" && id === 1){
            quotation.smtStencilParam["dimensionsID"] = 2;
        }else if(name === "framework" && id === 0){
            quotation.smtStencilParam["dimensionsID"] = 112;
        }
        /* Fetch price information for updated quotation */
        this.setState({quotation}, () => this.getPriceInfo());

        // console.log("DUO QUO ====> ", quotation);
        InitialQuotationState.gerberFileKey = InitialQuotationState.gerberImageData.key;
        console.log("STENCILLLL ===> ", quotation);
    };

    setGerberImageData = (imageData) => {
        this.setState({
            gerberImageData: imageData
        });

        InitialQuotationState.gerberImageData = imageData;
        InitialQuotationState.gerberFileKey = imageData.key;
    };

    setDimensions = (event) => {
        // console.log("event234", event.target.value);
        // console.log("event234", event.target.name);
        var rex = /[\uFF10-\uFF19]/g;

        let dimensionsVal = event.target.value;

        dimensionsVal = dimensionsVal.replace(rex, function(ch) {
            return String.fromCharCode(ch.charCodeAt(0) - 65248);
        });


        dimensionsVal = dimensionsVal.replace(/\u3002/g, ".");
        dimensionsVal = dimensionsVal.replace(/\s/g, '');

        if (event.target.name === "pcbWidth") {
            if (dimensionsVal !== "" || !(dimensionsVal.isEmpty)) {
                if (this.validateDimension(dimensionsVal))
                    this.setPCBParams({name: "width", id: parseFloat(dimensionsVal)})
            }
            if (dimensionsVal === "" || (dimensionsVal.isEmpty)) {
                this.setPCBParams({name: "width", id: ''})
            }
        } else if (event.target.name === "pcbLength") {
            if (dimensionsVal !== "" || !(dimensionsVal.isEmpty)) {
                if (this.validateDimension(event.target.value))
                    this.setPCBParams({name: "length", id: parseFloat(dimensionsVal)});
            }
            if (dimensionsVal === "" || (dimensionsVal.isEmpty)) {
                this.setPCBParams({name: "length", id: ''});
            }
        } else {
            this.setStencilParams({name: "dimensionsID", id: parseInt(event.target.value)})
        }

        InitialQuotationState.gerberFileKey = InitialQuotationState.gerberImageData.key;
    };

    validateDimension = (val) => {
        const pattern = /^[1-9]([0-9]*)(\.[0-9]{0,2})?$/;
        let regGreater = /^[1-9]([0-9]*)(\.[0-9]{0,1})?$/;
        // const pattern = /^[0-9\b]+$/;
        if (val < 100) {
            if (val.match(pattern)) {
                return true;
            } else {
                return false;
            }
        } else {
            if (val.match(regGreater)) {
                return true;
            } else {
                return false;
            }
        }

    };

    setQuantity = (event) => {
        if (event.target.name === "pcbQuantity") {
            this.setPCBParams({name: "qty", id: parseInt(event.target.value)})
            // this.setPCBParams({name: "qty", id: parseInt(event.target.value)})
        } else {
            this.setStencilParams({name: "stencilQty", id: event.target.value})
            // this.setStencilParams({name: "stencilQty", id: parseInt(event.target.value)})
        }

        InitialQuotationState.gerberFileKey = InitialQuotationState.gerberImageData.key;
    };

    setPCBQuantity = (value) => {
        this.setPCBParams({name: "qty", id: value})
    };

    setRemarks = (event) => {
        if (event.target.name === "stencilRemarks") {
            this.setStencilParams({name: "orderRemark", id: event.target.value})
        } else {
            this.setPCBParams({name: "orderDetailsRemark", id: event.target.value})
        }

        InitialQuotationState.gerberFileKey = InitialQuotationState.gerberImageData.key;
    };

    pcbWithStencilFormActivated = (event) => {
        let quotationParams = {...this.state.quotation};
        if (event.target.checked) {
            quotationParams["orderType"] = 2;
            this.setState({
                quotation: quotationParams,
            }, () => this.getPriceInfo());
        } else {
            quotationParams["orderType"] = 1;
            this.setState({
                quotation: quotationParams,
            }, () => this.getPriceInfo());
        }
    };

    pcbButtonClicked = () => {
        let quotationParams = {...this.state.quotation};
        quotationParams["orderType"] = 1;

        let gerberImageData = {...this.state.gerberImageData};
        gerberImageData["fileUrl"] = "";
        gerberImageData["id"] = -1;
        gerberImageData["imageUrl"] = "";
        gerberImageData["originalFileName"] = "";

        this.setState({
            pcbMode: true,
            quotation: quotationParams,
            gerberImageData,
            isFromTab: true
        }, () => this.getPriceInfo());
        InitialQuotationState.conformBtn = false;
    };

    stencilButtonClicked = () => {
        InitialQuotationState.qsdcls = ""
        let quotationParams = {...this.state.quotation};
        quotationParams["orderType"] = 3;

        let gerberImageData = {...this.state.gerberImageData};
        gerberImageData["fileUrl"] = "";
        gerberImageData["id"] = -1;
        gerberImageData["imageUrl"] = "";
        gerberImageData["originalFileName"] = "";

        this.setState({
            pcbMode: false,
            quotation: quotationParams,
            gerberImageData,
            isFromTab: true
        }, () => this.getPriceInfo());
        InitialQuotationState.conformBtn = false;

    };

    render() {
        ReactGA.initialize(GOOGLE_ANALYTICS_CODE);
        ReactGA.pageview(window.location.pathname + window.location.search);

        if (this.state.isFromTab && this.state.pcbMode !== this.props.location.pcbMode) {
            this.setState({
                pcbMode: this.props.location.pcbMode
            });
        }
        // console.log("ITEM ID DUO =====> ", this.state.gerberImageData);
        if (this.props.match.params.itemId === undefined) {
            this.state.cssStylePCBDisplay = {display: 'block'};
            this.state.cssStyleStencilDisplay = {display: 'block'};
        }
        // console.log("QUOTATION DUO ===== > ", this.state.quotation);

        return (
            <div className="quotation-content test-quotation-content">
                <div id="overlay-quo">
                    <div id="text-quo">
                        <img className="" src={PriceLoadingImage} alt="Loading..."/> &nbsp; <br className="loading-break-resp"/>お待ちください
                    </div>
                </div>
                <div className="row row-resp responsive-quotation">
                    <div className="col-md-8 quotation-responsive-content">
                        <div className="quotation-div">

                            {this.props.match.params.itemId !== undefined ?
                                <QuotationModeButtonGroupDisabled
                                    orderType={this.state.quotation.orderType}/> :

                                <QuotationModeButtonGroup
                                    pcbMode={this.state.pcbMode}
                                    pcbButtonClicked={this.pcbButtonClicked}
                                    stencilButtonClicked={this.stencilButtonClicked}/>
                            }

                            {this.state.errorMessage !== null ?
                                <div className="api-error-div text-center stb-pcb-select-responsive">{this.state.errorMessage}</div> : ""
                            }

                            <div className="container-fluid no-padding">

                                {this.state.pcbMode ?
                                    <PCBQuotationForm
                                        setDimensions={this.setDimensions}
                                        setStencilParams={this.setStencilParams}
                                        setQuantity={this.setQuantity}
                                        setRemarks={this.setRemarks}
                                        setGerberImageData={this.setGerberImageData}
                                        setPCBParams={this.setPCBParams}
                                        pcbWithStencilFormActivated={this.pcbWithStencilFormActivated}
                                        quotation={this.state.quotation}
                                        gerberImageData={this.state.gerberImageData}
                                        imageData={this.state.gerberImageData}
                                        getPriceInfo={this.getPriceInfo}
                                        locale={this.state.locale}
                                        setPCBQuantity={this.setPCBQuantity}
                                        gerberDivStyle={this.state.cssStylePCBDisplay}
                                        setDifferentDesign={this.setDifferentDesign}
                                        editMode={!isNaN(this.props.match.params.itemId)}
                                        setPCBParamsWhenGerberUpload={this.setPCBParamsWhenGerberUpload}
                                        unsetGerberError={this.unsetGerberError}
                                        setGerberError={this.setGerberError}
                                        gerberError={this.state.gerberError}
                                        setMainPriceInfo = {this.setMainPriceInfo}
                                        setLoadingPriceOnOff = {this.setLoadingPriceOnOff}
                                    />
                                    :
                                    < StencilQuotationForm
                                        setDimensions={this.setDimensions}
                                        setStencilParams={this.setStencilParams}
                                        setQuantity={this.setQuantity}
                                        setRemarks={this.setRemarks}
                                        setGerberImageData={this.setGerberImageData}
                                        quotation={this.state.quotation}
                                        gerberImageData={this.state.gerberImageData}
                                        imageData={this.state.gerberImageData}
                                        locale={this.state.locale}
                                        gerberDivStyle={this.state.cssStyleStencilDisplay}
                                        setPCBParamsWhenGerberUpload={this.setPCBParamsWhenGerberUpload}
                                        unsetGerberError={this.unsetGerberError}
                                        setGerberError={this.setGerberError}
                                        gerberError={this.state.gerberError}
                                        setMainPriceInfo = {this.setMainPriceInfo}
                                        setLoadingPriceOnOff = {this.setLoadingPriceOnOff}

                                    />
                                }

                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 left-div-container price-summery-fixed" id="price-summery-fixed">
                        <div className='pricing-inline'>
                            <div className="pricing-div">
                                <QuotationPriceInformation
                                    quotation={this.state.quotation}
                                    gerberImageData={this.state.gerberImageData}
                                    authenticate={this.props.authenticate}
                                    userData={this.props.userData}
                                    authenticated={this.props.authenticated}
                                    userId={this.props.userId}
                                    getCartItems={this.props.getCartItems}
                                    editMode={this.state.editMode}
                                    itemId={this.props.match.params.itemId}
                                    mainPriceInformation={this.state.mainPriceInformation}
                                    turnOnOverlay={this.turnOnOverlay}
                                    turnOffOverlay={this.turnOffOverlay}
                                    loadingPrice={this.state.loadingPrice}
                                    errorMessage={this.state.errorMessage}
                                    showPricingModal={this.state.showPricingModal}
                                    closePricingModal={this.closePricingModal}
                                />
                            </div>
                        </div>
                        <div className='summary-inline'>
                            <div className="summary-div">
                                <QuotationSummary
                                    quotation={this.state.quotation}
                                    gerberImageData={this.state.gerberImageData}
                                    authenticate={this.props.authenticate}
                                    userData={this.props.userData}
                                    authenticated={this.props.authenticated}
                                    userId={this.props.userId}
                                    mainPriceInformation={this.state.mainPriceInformation}
                                    getCartItems={this.props.getCartItems}
                                    editMode={this.state.editMode}
                                    itemId={this.props.match.params.itemId}
                                    showPricingModal={this.showPricingModal}

                                />
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.show === true &&
                <StencilCustomizedSize show={true}
                                       quotation={this.state.quotation}
                                       setCustomizedSize={this.setCustomizedSize}
                                       setStencilParams={this.setStencilParams}/>
                }


                <Modal dialogClassName="user-delete-modal" show={this.state.showPricingErrorDialog}
                       onHide={this.handleClosePricingErrorDialog}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            価格情報
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-12 data-label">

                                    <b><span className='font-color-red-alladmin'>
                                    価格情報が正常に受信できませんでした。
                                        <br/>
                                        再度仕様の設定お願いします。

                                    </span></b>
                                </div>


                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">

                            <button className="btn btn-primary col-md-2 pull-right"
                                    onClick={this.handleClosePricingErrorDialog}>
                                閉じる
                            </button>

                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default QuotationForm;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/QuotationForm.js